export default (url: string, paramMap: Record<string, string>) => {
	let replacedUrl = `${url}`;
	Object.entries(paramMap).map(([param, value]) => {
		const replaceRegex = new RegExp(`:${param}`, 'ig');
		replacedUrl = replacedUrl.replace(replaceRegex, value);
	});
	return replacedUrl;
};
